import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from '../../../components/Header/Header';
import Footer from '../../../components/Footer/Footer';

const AlertsPage = () => {
  const { type } = useParams();
  const { alerts } = useSelector((state) => state.dashboard);
  const navigate = useNavigate();

  const alertTypes = {
    'expired': { items: alerts.default, title: 'Expired Items' },
    'due-today': { items: alerts.danger, title: 'Due Today' },
    'due-soon': { items: alerts.alert, title: 'Due Soon' },
    'upcoming': { items: alerts.warning, title: 'Upcoming Items' }
  };

  const currentAlert = alertTypes[type];

  if (!currentAlert) {
    navigate('/dashboard');
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <Header />
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto p-6">
          <div className="flex items-center gap-4 mb-6">
            <button
              onClick={() => navigate('/Dashboard')}
              className="text-blue-600 hover:text-blue-800"
            >
              ← Back to Dashboard
            </button>
            <h2 className="text-xl font-bold">{currentAlert.title}</h2>
          </div>
          
          <div className="space-y-4">
            {currentAlert.items?.map((item, index) => (
              <div key={index} className="p-4 bg-white rounded-lg shadow">
                <div className="flex justify-between items-center">
                  <span className="font-medium">Indent #{item.IndentID}</span>
                  <span className={`text-sm ${item.daysLeft < 0 ? 'text-red-500' : 'text-gray-500'}`}>
                    {item.daysLeft < 0 ? `${Math.abs(item.daysLeft)} days overdue` : `${item.daysLeft} days left`}
                  </span>
                </div>
                <div className="text-sm text-gray-600 mt-2">
                  <p className="font-medium">{item.ItemName}</p>
                  <p>Project: {item.ProjectName}</p>
                  <p>Created by: {item.CreatedBy}</p>
                  <p>Due: {item.PromisedDate}</p>
                </div>
              </div>
            ))}
            {(!currentAlert.items || currentAlert.items.length === 0) && (
              <div className="text-center text-gray-500 py-8">
                No items to display
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AlertsPage;